// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__FcOLE","expandIconWrapper":"CustomNode_expandIconWrapper__2HqDM","isOpen":"CustomNode_isOpen__1A2c-","labelGridItem":"CustomNode_labelGridItem__3OQLb"};